function bannerHightlights() {
  const items = document.querySelectorAll('section[role="banner"] ul li');
  let current = 0;
  let paused = false;

  if (items.length) {

    const clearAll = () => { items.forEach((item, i) => { item.classList.remove('active') })};
    const pauseStart = function () { paused = true; clearAll(); this.classList.add('active'); };
    const pauseEnd = () => { clearAll(); paused = false; };

    // Start on first item
    items[0].classList.add('active');

    setInterval(() => {
      if (paused) return;
      items[current].classList.remove('active');
      current = (current + 1) % items.length;
      items[current].classList.add('active');
    }, 2500); // ms per item




    // Pause on hover so mouse users still work
    items.forEach((el, i) => {
      el.addEventListener('mouseenter', pauseStart);
      el.addEventListener('mouseleave', pauseEnd);
      el.addEventListener('touchstart', pauseStart);
      el.addEventListener('touchend', pauseEnd);
    });
  }
}

document.addEventListener("turbo:load", bannerHightlights);
